import { createAction, props } from "@ngrx/store";
import { InvestmentItemModel } from "src/app/model/investment-item.model";
import { InvestmentsModel } from "./state";

export const ResetDataSavedAction = createAction('[Investments Form] reset data saved property');

export const InvestmentOptionsListRequestAction = createAction('[Investments Form] get investment options');

export const InvestmentOptionsListResponseAction = createAction('[Investments Form] set investment options', props<{ investmentOptions: InvestmentItemModel[] }>());

export const SaveInvestmentOptionsRequestAction = createAction('[Investments Form] save investment options',
    props<{ step: number, field: string, data: InvestmentsModel }>());

export const SaveInvestmentOptionsResponseActions = createAction('[Investments Form] update next page response');

export const UpdateManualSplitSelectedAction = createAction('[Investments Form] update manual split selection', props<{ isManualSplit: boolean }>());

export const SetUpdatedOptionsAction = createAction('[Investments Form] update options with manual entry option', props<{ investmentOptions: InvestmentItemModel[] }>());

export const AllocateAllToOptionAction = createAction('[Investments Form] allocate 100% to investment option', props<{ investmentOptionId: number }>());